// Chart & table data for the Skillvue GDO report

export const fatturatoPieData = [
  { name: 'Costo del lavoro', value: 9.8, fill: '#e8690a' },
  { name: 'Margine EBIT', value: 2.9, fill: '#8b5cf6' },
  { name: 'Altri costi', value: 87.3, fill: '#e2e8f0' },
];

export const discountLineData = [
  { anno: '2010', quota: 12.5 },
  { anno: '2015', quota: 15.2 },
  { anno: '2020', quota: 18.5 },
  { anno: '2024', quota: 20.6 },
  { anno: '2030P', quota: 27.5 },
];

export const quoteMercatoPieData = [
  { name: 'Conad', value: 16.7, fill: '#e8690a' },
  { name: 'Selex', value: 15.7, fill: '#8b5cf6' },
  { name: 'Coop', value: 13.9, fill: '#f59e0b' },
  { name: 'Esselunga', value: 9.8, fill: '#06b6d4' },
  { name: 'Eurospin', value: 8.5, fill: '#10b981' },
  { name: 'Lidl', value: 7.2, fill: '#6366f1' },
  { name: 'Altri', value: 28.2, fill: '#d1d5db' },
];

export const confrontoFormatiData = [
  { name: 'EBIT %', Discount: 4.8, Tradizionale: 2.3 },
  { name: 'ROI %', Discount: 16.5, Tradizionale: 5.9 },
];

export const genZData = [
  { name: 'Work-life balance', value: 73 },
  { name: 'Finalità lavoro', value: 86 },
  { name: 'Flessibilità', value: 71 },
];

export const turnoverImpactData = [
  { name: 'Conservativo', costo: 33, ebit: 22.8 },
  { name: 'Elevato', costo: 110, ebit: 75.9 },
];

export const ceoPrioritiesData = [
  { name: 'Capitale umano', value: 78.3 },
  { name: 'AI e tecnologia', value: 71.2 },
  { name: 'Iper-personaliz.', value: 58.4 },
  { name: 'Espansione rete', value: 45.7 },
  { name: 'Sviluppo MDD', value: 38.1 },
];

export const costoLavoroTable = [
  { label: 'Costo del lavoro GDO / anno', value: '€10,7 miliardi' },
  { label: 'Incidenza sul fatturato', value: '9,8%' },
  { label: 'Margine EBIT medio', value: '2,9%' },
  { label: 'Costo per singola uscita', value: '€11.000 – €110.000' },
  { label: 'Turnover medio settore (2024)', value: '13,3% (da 8,2%)' },
];

export const confrontoTable = [
  { indicatore: 'Margine EBIT', discount: '4,8%', tradizionale: '2,3%', delta: '+2,5 pp' },
  { indicatore: 'ROI', discount: '16,5%', tradizionale: '5,9%', delta: '+10,6 pp' },
  { indicatore: 'Redd. cumulata Eurospin', discount: '€1,56 mld', tradizionale: '—', delta: '—' },
];

export const turnoverTable = [
  { variabile: 'Dipendenti', conservativo: '20.000', elevato: '20.000' },
  { variabile: 'Turnover', conservativo: '15%', elevato: '25%' },
  { variabile: 'Uscite annue', conservativo: '3.000', elevato: '5.000' },
  { variabile: 'Costo/uscita', conservativo: '€11.000', elevato: '€22.000' },
  { variabile: 'Costo annuo turnover', conservativo: '€33 mln', elevato: '€110 mln' },
  { variabile: 'Impatto su EBIT', conservativo: '22,8%', elevato: '75,9%' },
];

export const aiTable = [
  { app: 'Demand forecasting', impatto: '+50% accuratezza, -40/60% stock-out', fonte: 'BCG/Neontri' },
  { app: 'Dynamic pricing', impatto: '+2-5% margine, +3-7% ricavi', fonte: 'BCG' },
  { app: 'Personalizzazione', impatto: '+25% conversioni', fonte: 'Eur. Retail Tech Council' },
  { app: 'Retail media (2025)', impatto: '€640 mln, potenziale >€1 mld', fonte: 'Polimi/IAB Europe' },
];

export const erosionAreas = [
  { num: 1, title: 'Selezione ad alto volume', desc: 'Turnover concentrato nei primi 12-18 mesi: si assume in fretta, si seleziona male, si perde presto.' },
  { num: 2, title: 'Pipeline store manager', desc: 'Figura chiave per la performance del punto vendita. La carenza diventa vincolo diretto alla crescita.' },
  { num: 3, title: 'Successione generazionale', desc: 'Quando un responsabile va in pensione senza successore formato, l\'impatto operativo è immediato.' },
  { num: 4, title: 'Gap competenze digitali', desc: 'Investimenti digitali al 4,7% del fatturato ma rendimento solo con persone competenti.' },
  { num: 5, title: 'Retention e formazione', desc: 'Esselunga: 800.000 ore/anno per 29.000 dipendenti. Con il 35% turnover under-30, l\'investimento si disperde.' },
  { num: 6, title: 'Uniformità di valutazione', desc: 'Standard coerenti per cooperative con migliaia di punti vendita sono prerequisito per l\'efficienza.' },
];
